// extracted by mini-css-extract-plugin
export var boxItems = "_6u-1";
export var boxItemsLg = "_6u-2";
export var button = "_6u-7";
export var buttonHoverless = "_6u-9";
export var buttonLg = "_6u-8";
export var filterGroupBox = "_6u-0";
export var icon = "_6u-3";
export var iconSecondary = "_6u-6";
export var iconWrapper = "_6u-4";
export var iconWrapperLg = "_6u-5";
export var truncatedLabel = "_6u-a";